<template lang="pug">
  .support-kb-sources(v-loading="loading")
    .support-page-header
      el-button(size="small" @click="goBack") ← Volver a KB
      h1 Explorador de fuentes
      .support-page-actions
        el-button(size="small" @click="reload") ⟲ Refrescar

    el-card
      div(v-for="f in files" :key="f.file" style="margin-bottom: 16px")
        h3(style="margin-bottom: 8px") 📄 {{ f.file }}
        el-table(:data="f.sections" size="small")
          el-table-column(prop="title" label="Sección" min-width="240")
          el-table-column(label="Estado" width="160")
            template(slot-scope="s")
              el-tag(:type="statusTagType(s.row.status)" size="mini") {{ s.row.status }}
          el-table-column(label="Acción" width="200" align="right")
            template(slot-scope="s")
              el-button(v-if="s.row.status === 'not-imported'" size="mini" type="primary" @click="importFile(f.file)") Importar este archivo
              el-button(v-else size="mini" @click="goToArticle(s.row.articleId)") Ver artículo
</template>

<script>
import supportService from "@/services/support";

/**
 * @component KBSourcesExplorer
 * @description Vista del árbol de docs/kb/ con estado de cada sección
 *              (Fase 2 — UC-REG-098). Permite importar nuevos .md.
 * @example <KBSourcesExplorer />
 */
export default {
  name: "KBSourcesExplorer",
  data() {
    return {
      files: [],
      loading: false,
    };
  },
  mounted() {
    this.reload();
  },
  methods: {
    /**
     * @description Refresca el árbol desde el backend.
     */
    async reload() {
      this.loading = true;
      try {
        const data = await supportService.listSources();
        this.files = data.files;
      } catch (err) {
        this.$message.error("No pude cargar las fuentes.");
      } finally {
        this.loading = false;
      }
    },
    /**
     * @description Importa un .md completo.
     * @param {string} file
     */
    async importFile(file) {
      try {
        const result = await supportService.importSourceFile(file);
        this.$message.success(
          `Importadas: ${result.imported.length}, skipped: ${result.skipped.length}`
        );
        await this.reload();
      } catch (err) {
        this.$message.error("No pude importar.");
      }
    },
    /**
     * @description Color del tag según estado.
     * @param {string} status
     * @returns {string}
     */
    statusTagType(status) {
      if (status === "synced") return "success";
      if (status === "drifted") return "warning";
      if (status === "not-imported") return "info";
      if (status === "missing-in-repo") return "danger";
      return "";
    },
    goToArticle(id) {
      this.$router.push({ name: "support-kb-edit", params: { id } });
    },
    goBack() {
      this.$router.push({ name: "support-kb-list" });
    },
  },
};
</script>

<style lang="scss" scoped>
.support-page-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
  h1 {
    margin: 0;
    font-size: 22px;
    color: #002d5e;
    flex: 1;
  }
}
.support-page-actions {
  display: flex;
  gap: 8px;
}
</style>
